<template>
  <!-- <div id="workbench"></div> -->
  <div id="review-report">
    <div class="ipub-h1 line-h-40  mar-b-20">
      Submit Decision
    </div>
    <div class="content-bg"
         style="padding-bottom:10px">
      <div class="mar-b-10">
        <div class="ipub-title-tab line-h-40 ipub-h3 mar-b-10">Manuscript Information</div>
        <div class="ipub-p2 ipub-title-tab-part">
          <div class="flex  mar-b-12">
            <span class="fw-bd ipub-block__span">Manuscript No.</span>
            <span class="ipub-block__font">{{reviewsResponse.code}}</span>
          </div>
          <div class="flex mar-b-12">
            <span class="ipub-block__span fw-bd">Article Type</span>
            <span class="ipub-block__font">{{manuscriptType[reviewsResponse.typeCode]}}</span>
          </div>
          <div class="flex  mar-b-12">
            <span class="ipub-block__span fw-bd">Article Title</span>
            <span class="ipub-block__font">{{reviewsResponse.title}}</span>
          </div>
          <div class="flex"
               v-if="reviews.forReviewerFileList && reviews.forReviewerFileList.length">
            <span class="ipub-block__span fw-bd"
                  style="line-height:30px">Attachment(s)</span>
            <div class=" ipub-block__font">
              <ipub-label style="margin-right:10px"
                          type="link"
                          class="ipub-c-p ipub-p2"
                          v-for="(item,index) in reviews.forReviewerFileList"
                          :key="item.id">
                <ipub-radio :checked="item.authorShowed"
                            @change="reviewAuthor(item)"
                            checkBox
                            label="" />
                <font class="mar-l-6">{{item.name}}</font>
                <ipub-icon class="ipub-p2 mar-l-20"
                           @click="download(item,index)"
                           type="iconDownload1" />
              </ipub-label>
            </div>

          </div>
        </div>
      </div>

      <div class="mar-b-20">
        <div class="ipub-h3 line-h-40  mar-b-10 ipub-title-tab">
          Editor Decision
        </div>
        <div class="ipub-title-tab-part">
          <ipub-form ref="reviews-commit"
                     :model="reviews"
                     :rules="rules">
            <div class="flex mar-b-10">
              <div>
                <span class="ipub-p2 fw-bd">Editor Decision</span>
                <font class="key-color">*</font>
              </div>
              <ipub-radio-group v-model="reviews.decisionStatus"
                                class="mar-l-16">
                <ipub-radio v-for="(value, key) in  statu==0? AUTHOR_REVISION:DECISION"
                            :key="key"
                            :value="key">
                  <div style="margin-right:22px"
                       class="ipub-p2">{{ value }}</div>
                </ipub-radio>
              </ipub-radio-group>
            </div>
            <div class="flex mar-b-10"
                 v-show="['PENDING_MINOR_REVISIONS','PENDING_MAJOR_REVISIONS'].includes(reviews.decisionStatus) || statu===0">
              <span class="ipub-p2 fw-bd line-h-40">Revision Due Date</span>
              <ipub-date-picker prop="reviseDueTime"
                                class="mar-l-10"
                                style="width:300px"
                                placeholder="Revision Due Date"
                                @change="changeDate"
                                v-model="reviews.reviseDueTime">
              </ipub-date-picker>
            </div>
            <div class="mar-b-20">
              <div class="ipub-p2 fw-bd">
                Comments to Author
              </div>
              <ipub-textarea placeholder="Comments to Author"
                             v-model.trim="reviews.authorNotes"
                             :autoSize="{ cols: '', rows: '10' }" />
            </div>
            <div class="mar-b-20">
              <div class="ipub-p2 fw-bd">
                Comments to Editor
              </div>
              <ipub-textarea placeholder="Comments to Editor"
                             v-model.trim="reviews.editorNotes"
                             :autoSize="{ cols: '', rows: '10' }" />
            </div>

            <div class="ipub-p2 fw-bd flex fw-bd line-h-20 relative mar-b-10">
              <div>Attachment(s)</div>
              <div class="mar-l-20">
                <ipub-upload v-if="!loading"
                             @change="handleUpload"
                             multiple
                             class="link-color ipub-c-p">
                  <ipub-icon type="iconAdd" /> Add New Review Document
                </ipub-upload>
                <font class="line-color"
                      v-else>
                  <ipub-icon :type="loading?'loading':'iconAdd'" /> Add New Review Document
                </font>
              </div>
            </div>

            <div class="mar-b-30">
              <ul class="flex">
                <ipub-label class="mar-b-10 flex"
                            style="margin-right:20px"
                            :key="'reviewerFileList'+index"
                            v-for="(item,index) in reviewerFileList">
                  <ipub-radio :checked="item.authorShowed"
                              @change="reviewAuthor(item)"
                              checkBox
                              label="" />
                  <div class="ipub-p2 mar-l-10"
                       style="cursor:pointer">{{item.name}}
                    <ipub-icon class="ipub-p2 mar-l-20 border-right"
                               @click="download(item,index)"
                               type="iconDownload1" />
                  </div>
                  <ipub-icon class="ipub-p2 mar-l-10 ipub-cursor-pointer"
                             @click="del(index)"
                             type="iconDelete" />
                </ipub-label>
              </ul>
            </div>
          </ipub-form>
          <div>
            <ipub-button type="primary"
                         plain
                         :style="{ minWidth: '150px' }"
                         @click="$router.go(-1)">Back</ipub-button>
            <ipub-button v-if="user.codeList&& user.codeList.includes('EDITOR_TASK.MANUSCRIPTS.MANUSCRIPT_DETAILS.GO_TO_AUTHOR_REVISION.SAVE') "
                         type="primary"
                         plain
                         :style="{ minWidth: '150px' }"
                         @click="commit('save')">Save</ipub-button>
            <ipub-button v-if="user.codeList&&user.codeList.includes('EDITOR_TASK.MANUSCRIPTS.MANUSCRIPT_DETAILS.GO_TO_AUTHOR_REVISION.SEND_TO_AUTHOR')"
                         type="primary"
                         plain
                         :style="{ minWidth: '150px' }"
                         @click="commit('author')">Send to Author</ipub-button>
          </div>
        </div>
      </div>

      <div class="mar-b-20">
        <div class="ipub-h3 line-h-40  mar-b-12 ipub-title-tab"
             @click="()=>{showVersion1 = !showVersion1}"
             v-show="reviewsResponse.editorDecisionHistoryList && reviewsResponse.editorDecisionHistoryList.length>0">
          Version <span class="ipub-h6">{{reviewsResponse.sign}}</span> Decision History
          <ipub-icon :class="[' mar-l-40 rotate ipub-cursor-pointer',showVersion1?'rotate-180':'']"
                     type="iconArrow" />
        </div>
        <div v-show="showVersion1 && reviewsResponse.editorDecisionHistoryList && reviewsResponse.editorDecisionHistoryList.length>0"
             class="ipub-title-tab-part"
             v-for="(item,index) in reviewsResponse.editorDecisionHistoryList"
             :key="'editorHistory'+index">
          <div class="ipub-h6  mar-b-12">
            <span class="link-color fw-bd">Professor {{item.macademicId ? item.macademic.firstName : item.editor.firstName}} {{item.macademicId ? item.macademic.lastName : item.editor.lastName}}</span> ({{item.editor.email}})
          </div>
          <div class="ipub-p2">
            <div class="flex mar-b-12">
              <span class="fw-bd ipub-block__span ">Invited Date</span>
              <span class="ipub-block__font">{{item.completedTime ? $moment(item.assignedTime).format('DD / MM / YYYY') : '--'}}</span>
            </div>
            <div class="flex mar-b-12">
              <span class="fw-bd ipub-block__span">Decision Date</span>
              <div class="font-color mar-b-10">{{item.completedTime ? $moment(item.completedTime).format('DD / MM / YYYY') : '--'}}</div>
            </div>
            <div class="flex mar-b-12">
              <span class="fw-bd ipub-block__span">Decision</span>
              <div class="font-color mar-b-10 ipub-block__font">{{termListStatus[item.decisionStatus]}} </div>
            </div>
            <div class="flex mar-b-12">
              <span class="fw-bd  ipub-block__span">Comments to Editor</span>
              <div class="ipub-block__font">
                <div class="ipub-p2 font-color"
                     v-if="item.editorNotes && item.editorNotes.length>500">
                  <span v-if="!item.isMoreText"> {{item.editorNotes.substr(0,500)+'...'}}</span>
                  <span v-if="item.isMoreText"> {{item.editorNotes}}</span>
                  <a class="link-color"
                     @click="togalReport(item,'isMoreText')">
                    {{item.isMoreText?'Hidden':'View More'}}
                  </a>
                </div>
                <div :class="['ipub-p2',item.editorNotes?'font-color':'line-color']"
                     v-else>{{item.editorNotes || 'No notes or comments.'}}</div>
              </div>
            </div>
            <span class="ipub-p2 fw-bd ipub-block__span">Comments to Author</span>
            <div class="ipub-block__font">
              <div class="ipub-p2 font-color"
                   v-if="item.authorNotes && item.authorNotes.length>500">
                <span v-if="!item.isMoreText1"> {{item.authorNotes.substr(0,500)+'...'}}</span>
                <span v-if="item.isMoreText1"> {{item.authorNotes}}</span>
                <a class="link-color"
                   @click="togalReport(item,'isMoreText1')">
                  {{item.isMoreText1?'Hidden':'View More'}}
                </a>
              </div>
              <div :class="['ipub-p2',item.authorNotes?'font-color':'line-color']"
                   v-else>{{item.authorNotes || 'No notes or comments.'}}</div>
            </div>
          </div>
        </div>
      </div>

      <div class="mar-b-10">
        <div class="ipub-h3 mar-b-10 line-h-40 ipub-title-tab"
             @click="()=>{showDecision1 = !showDecision1}"
             v-show="reviewsResponse.reviewerList && reviewsResponse.reviewerList.length>0">
          Reviewer Decision
          <ipub-icon :class="[' mar-l-40 rotate ipub-cursor-pointer',showDecision1?'rotate-180':'']"
                     type="iconArrow" />
        </div>
        <div v-show="showDecision1 && reviewsResponse.reviewerList && reviewsResponse.reviewerList.length>0"
             class="ipub-title-tab-part">
          <li class="flex mar-b-12 ipub-border"
              style="padding:6px 12px"
              v-for="(item,index) in reviewsResponse.reviewerList"
              :key="item.id">
            <p class="ipub-p2 fw-bd"
               style="width:8%">Reviewer {{item.seq}}</p>
            <p class="ipub-p2 fw-bd"
               style="width:18%;">{{item.firstName}} {{item.lastName}}</p>

            <p class="ipub-p2 fw-bd"
               style="width:54%">{{termListStatus[item.reviewerDecisionList[0].decisionStatus] }} (Report sent on {{$moment(item.reviewerDecisionList[0].completedTime).format('MMMM Do YYYY')}})
              <span v-if="item.reviewerDecisionList.length>1">(includes<a class="act-font-color"
                   :href="'#toReport'+index"> author’s reply</a>)</span>
            </p>

            <p class="ipub-p2 fw-bd"
               style="width:20%">Last decision: {{item.reviewerDecisionList[0].lastSign ? termListStatus[item.reviewerDecisionList[0].lastSign.decisionStatus] : null}}</p>
          </li>
        </div>
      </div>

      <div v-for="(item,index) in reviewsResponse.reviewerList"
           :key="'reviewer'+index"
           v-show="reviewsResponse.reviewerList">
        <div class="mar-b-10">
          <div class="ipub-h3 line-h-40 ipub-title-tab mar-b-10"
               @click="togalReviewer(item)">
            Reviewer {{item.seq}}: {{item.firstName}} {{item.lastName}}, {{item.rank}}
            <ipub-icon :class="[' mar-l-40 rotate ipub-cursor-pointer',item.showReviewer?'rotate-180':'']"
                       type="iconArrow" />
          </div>
          <div v-show="item.showReviewer"
               class="ipub-title-tab-part">
            <div class="ipub-p2">
              <div class="flex mar-b-10">
                <div class="ipub-block__span fw-bd">Email</div>
                <div class="ipub-block__font">{{item.email}}</div>
              </div>
              <div class="flex mar-b-10">
                <div class="ipub-block__span fw-bd">Country / Territory</div>
                <div class="ipub-block__font">{{country[item.countryCode]}}</div>
              </div>
              <div class="flex mar-b-10">
                <div class="ipub-block__span fw-bd">Affiliation</div>
                <div class="ipub-block__font">{{item.affiliation}}</div>
              </div>
              <div class="flex mar-b-10">
                <div class="ipub-block__span fw-bd">Research Keywords</div>
                <div class="ipub-block__font">{{item.keyword?item.keyword:'--'}}</div>
              </div>
            </div>
          </div>
        </div>
        <!-- ()=>{showReport1 = !showReport1} -->
        <div class="mar-b-20"
             v-for="(itemrep,indexrep) in item.reviewerDecisionList"
             :key="itemrep.id">
          <div class="ipub-p1 line-h-40 mar-b-12 font-color ipub-title-report"
               @click="togalReport(itemrep,'showReport')">
            Report {{item.reviewerDecisionList.length-indexrep}} Decision: {{termListStatus[itemrep.decisionStatus]}}
            <ipub-icon :class="[' mar-l-40 rotate ipub-cursor-pointer',itemrep.showReport?'':'rotate-180']"
                       type="iconArrow" />
          </div>
          <div v-if="!itemrep.showReport"
               class="ipub-title-tab-part">
            <div>
              <div class="ipub-p2 fw-bd mar-b-12">
                <span>Review the Revised Manuscript:</span><span class="mar-l-10">{{itemrep.revised?'Yes':'No'}}</span>
              </div>
              <div class="ipub-p2 fw-bd mar-b-12">
                Custom Review Questions
              </div>
              <div class="question-answer">
                <customerReviewQuestion :questionList="itemrep.questionList"></customerReviewQuestion>
              </div>
            </div>
            <div class="mar-b-20">
              <div class="ipub-p2 fw-bd">
                Comments to Editor
              </div>
              <ipub-textarea placeholder="Comments to Editor"
                             v-model="itemrep.editorNotes"
                             v-if="indexrep === 0"
                             :autoSize="{ cols: '', rows: '10' }" />
              <div v-if="indexrep!=0"
                   style="padding:10px 8px"
                   class="ipub-p2 ipub-border"
                   v-html="itemrep.editorNotes ?itemrep.editorNotes.replace(/\r\n/g,'<br/>').replace(/\n/g,'<br/>').replace(/\s/g,' '):'--'"></div>
            </div>
            <div class="mar-b-20">
              <div class="ipub-p2 fw-bd">
                Comments to Author
              </div>
              <ipub-textarea placeholder="Comments to Author"
                             v-model="itemrep.authorNotes"
                             v-if="indexrep === 0"
                             :autoSize="{ cols: '', rows: '10' }" />
              <div v-if="indexrep!=0"
                   class="ipub-p2 ipub-border"
                   style="padding:10px 8px"
                   v-html="itemrep.authorNotes?itemrep.authorNotes.replace(/\r\n/g,'<br/>').replace(/\n/g,'<br/>').replace(/\s/g,' '):'--'"></div>
            </div>

            <div class="mar-b-10">
              <div class="ipub-p2 fw-bd flex line-h-20 relative mar-b-10"
                   v-show="(itemrep.reviewerFileList && itemrep.reviewerFileList.length>0) || indexrep===0">
                <div>Attachment(s)</div>
                <div v-if="indexrep === 0">
                  <div class="mar-l-20">
                    <ipub-upload v-if="!loading"
                                 @change="e=>{handleUpload1(e,itemrep,index,'reviewerFileList')}"
                                 multiple
                                 class="link-color ipub-c-p">
                      <ipub-icon type="iconAdd" /> Add New Review Document
                    </ipub-upload>
                    <font class="line-color"
                          v-else>
                      <ipub-icon :type="loading?'loading':'iconAdd'" /> Add New Review Document
                    </font>
                  </div>
                </div>
              </div>
              <div class="">
                <ul class="flex">
                  <ipub-label class="mar-b-10 flex"
                              style="margin-right:10px"
                              :key="'reviewerfile'+indexfile"
                              v-for="(itemfile,indexfile) in itemrep.reviewerFileList">
                    <ipub-radio :checked="itemfile.authorShowed"
                                @change="authorStatus(itemfile)"
                                :disabled="indexrep != 0  && !itemfile.reviewerSelf"
                                checkBox
                                label="" />
                    <div class="ipub-p2 file-item ipub-cursor-pointer"
                         @click="download(itemfile,indexfile)">{{itemfile.name}}
                    </div>
                    <ipub-icon class=" mar-l-20 ipub-cursor-pointer"
                               @click="del1(itemrep,indexfile,'reviewerFileList')"
                               v-if="itemfile.reviewerSelf"
                               type="iconDelete" />
                  </ipub-label>
                </ul>
              </div>
            </div>

            <div v-if="indexrep!=0 && (itemrep.authorReply || (itemrep.authorReplyFileList && itemrep.authorReplyFileList.length>0))">
              <a :name="'toReport'+index">
                <div class="ipub-p2 fw-bd  mar-b-12 font-color">
                  Author’s Response to Report {{item.reviewerDecisionList.length-indexrep}}
                </div>
                <div>
                  <div class="mar-b-20">
                    <div class="ipub-p2 fw-bd fw-bd line-h-40  mar-b-5">
                      Author’s Note
                    </div>
                    <ipub-textarea placeholder="Author’s Note"
                                   v-if="reviewsResponse.sign-1===itemrep.sign"
                                   v-model="itemrep.authorReply"
                                   :autoSize="{ cols: '', rows: '5' }" />
                    <div class="ipub-p2 ipub-border"
                         v-else
                         style="padding:10px 8px"
                         v-html="itemrep.authorReply && itemrep.authorReply.replace(/\r\n/g,'<br/>').replace(/\n/g,'<br/>').replace(/\s/g,' ')"></div>
                  </div>
                  <div class="mar-b-20"
                       v-show="itemrep.authorReplyFileList && itemrep.authorReplyFileList.length>0">
                    <div class="ipub-p2 fw-bd mar-b-10 flex">
                      Author’s Response File
                      <div v-if="reviewsResponse.sign-1===itemrep.sign">
                        <div class="mar-l-20">
                          <ipub-upload v-if="!loading"
                                       @change="e=>{handleUpload1(e,itemrep,index,'authorReplyFileList')}"
                                       multiple
                                       class="link-color ipub-c-p">
                            <ipub-icon type="iconAdd" /> Add New Review Document
                          </ipub-upload>
                          <font class="line-color"
                                v-else>
                            <ipub-icon :type="loading?'loading':'iconAdd'" /> Add New Review Document
                          </font>
                        </div>
                      </div>
                    </div>
                    <div class="flex">
                      <ipub-label class="mar-b-10"
                                  style="margin-right:10px;cursor:pointer"
                                  :key="itemauth.id"
                                  v-show="itemauth.authorShowed"
                                  v-for="(itemauth,indexauth) in itemrep.authorReplyFileList">
                        <span class="ipub-p2 ipub-cursor-pointer">{{itemauth.name}} </span>
                        <ipub-icon class="ipub-p2 mar-l-10 ipub-cursor-pointer"
                                   @click="download(itemauth,indexauth)"
                                   type="iconDownload1" />
                        <ipub-icon class="ipub-p2 mar-l-10 ipub-cursor-pointer border-left"
                                   @click="del1(itemrep,indexauth,'authorReplyFileList')"
                                   type="iconDelete" />
                      </ipub-label>
                    </div>
                  </div>
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>

    <SendEmail :isVisable="showSendEmail"
               :inputData="inputData"
               :files="files"
               :event="event"
               @send="send"
               @cancel="showSendEmail=false" />
  </div>
</template>



<script>
import main from './main.js'
export default main

</script>

<style lang="scss" scoped>
@import './main.scss';
.act-font-color {
  color: #1b65a6;
}
.ipub-radio {
  align-items: center;
}
</style>
